import { render, staticRenderFns } from "./BookerInvoice.vue?vue&type=template&id=4fd1a6c4&scoped=true"
import script from "./BookerInvoice.vue?vue&type=script&lang=js"
export * from "./BookerInvoice.vue?vue&type=script&lang=js"
import style0 from "./BookerInvoice.vue?vue&type=style&index=0&id=4fd1a6c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd1a6c4",
  null
  
)

export default component.exports